import { render, staticRenderFns } from "./Script.vue?vue&type=template&id=147cd634"
import script from "./Script.vue?vue&type=script&lang=js"
export * from "./Script.vue?vue&type=script&lang=js"
import style0 from "./Script.vue?vue&type=style&index=0&id=147cd634&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports